import { ReactNode } from 'react';

import { LoanType } from '../cerberus/Cerberus';
import { InputLayoutTheme } from '../forms/InputLayout.types';

import {
  MlsStatus,
  PortfolioAvmReferences,
  PortfolioAvmThresholdFields,
  PortfolioAvmThresholdOperators,
  PortfolioAvmThresholdValueFields,
  PortfolioGtLtThresholdOperators,
} from './Portfolio.types';

export interface PortfolioFormFieldCommonProps {
  className?: string;
  fullWidth?: boolean;
  theme?: InputLayoutTheme;
}
export interface PortfolioFormFieldConfig {
  label: ReactNode;
  placeHolder?: string;
  field: string;
}

export enum PortfolioFormFields {
  Name = 'name',
  NotificationType = 'notificationType',
  MlsStatus = 'mlsStatus',
  LtvThresholds = 'ltvThresholds',
  AvmThresholds = 'avmThresholds',
  PropensityToListThresholds = 'propensityToListThresholds',
  PropensityToRefiThresholds = 'propensityToRefiThresholds',
  Liens = 'liens',
  Nod = 'nod',
  Emails = 'emails',
  WebhookUrl = 'webhookUrl',
  WebhookUsername = 'username',
  WebhookPassword = 'password',
}

export enum PortfolioFormNotificationTypes {
  Nod = 'NOD',
  Mls = 'MLS',
  Ltv = 'LTV',
  Avm = 'AVM',
  Lien = 'LIEN',
  PropensityToList = 'PROPENSITY_TO_LIST',
  PropensityToRefi = 'PROPENSITY_TO_REFI',
}

interface PortfolioFormGtLtThreshold {
  operator: PortfolioGtLtThresholdOperators;
  threshold: number | null;
}

interface PortfolioFormAvmThresholdValue {
  [PortfolioAvmThresholdValueFields.Operator]: PortfolioAvmThresholdOperators;
  [PortfolioAvmThresholdValueFields.Value]: number | null;
}

interface PortfolioFormAvmThresholds {
  [PortfolioAvmThresholdFields.RelativeTo]: PortfolioAvmReferences;
  [PortfolioAvmThresholdFields.Thresholds]:
    | PortfolioFormAvmThresholdValue[]
    | null;
}

export interface PortfolioForm {
  [PortfolioFormFields.Name]: string;
  [PortfolioFormFields.Emails]: string[];
  [PortfolioFormFields.NotificationType]: PortfolioFormNotificationTypes[];
  [PortfolioFormFields.LtvThresholds]: PortfolioFormGtLtThreshold[] | null;
  [PortfolioFormFields.AvmThresholds]: PortfolioFormAvmThresholds | null;
  [PortfolioFormFields.PropensityToListThresholds]:
    | PortfolioFormGtLtThreshold[]
    | null;
  [PortfolioFormFields.PropensityToRefiThresholds]:
    | PortfolioFormGtLtThreshold[]
    | null;
  [PortfolioFormFields.MlsStatus]: MlsStatus[] | null;
  [PortfolioFormFields.Nod]: boolean | null;
  [PortfolioFormFields.Liens]: LoanType[] | null;
  [PortfolioFormFields.WebhookUrl]: string | null;
  [PortfolioFormFields.WebhookUsername]?: string | null;
  [PortfolioFormFields.WebhookPassword]?: string | null;
}
